import { useAppSelector } from '../../../app/hooks';
import { SnapshotTraceHistoryCombination } from '../types';

import { Snapshot } from 'types';

export const useIsSnapshotLocked = (
  selectedSnapshot:
    | Snapshot
    | SnapshotTraceHistoryCombination
    | undefined
    | false
) => {
  const user = useAppSelector((state) => state.auth.user);
  if (selectedSnapshot === false) return true;
  return (
    selectedSnapshot?.lock_user_id !== null &&
    selectedSnapshot?.lock_user_id !== undefined &&
    selectedSnapshot?.lock_user_id !== user?.id
  );
};
